import { Outlet } from 'react-router-dom'

const Garuda = () => <Outlet />

export default Garuda
